import { FormErrors, LoginCredentials, SignupData } from '../types';
import { AUTH_ERROR_MESSAGES, VALIDATION_PATTERNS } from '../constants';

export const validateEmail = (email: string): string | null => {
    if (!email.trim()) {
        return AUTH_ERROR_MESSAGES.EMAIL_REQUIRED;
    }
    
    if (!VALIDATION_PATTERNS.EMAIL.test(email)) {
        return AUTH_ERROR_MESSAGES.INVALID_EMAIL;
    }
    
    return null;
};

export const validatePassword = (password: string, minLength: number = 8): string | null => {
    if (!password) {
        return AUTH_ERROR_MESSAGES.PASSWORD_REQUIRED;
    }
    
    if (password.length < minLength) {
        return AUTH_ERROR_MESSAGES.PASSWORD_TOO_SHORT;
    }
    
    return null;
};

export const validateName = (name: string, fieldName: 'firstName' | 'lastName'): string | null => {
    if (!name.trim()) {
        return fieldName === 'firstName' 
            ? AUTH_ERROR_MESSAGES.FIRST_NAME_REQUIRED 
            : AUTH_ERROR_MESSAGES.LAST_NAME_REQUIRED;
    }
    
    if (name.trim().length < 2) {
        return `${fieldName === 'firstName' ? 'First' : 'Last'} name must be at least 2 characters`;
    }
    
    if (!VALIDATION_PATTERNS.NAME.test(name)) {
        return `${fieldName === 'firstName' ? 'First' : 'Last'} name contains invalid characters`;
    }
    
    return null;
};

export const validateLoginForm = (credentials: LoginCredentials): FormErrors => {
    const errors: FormErrors = {};
    
    const emailError = validateEmail(credentials.email);
    if (emailError) errors.email = emailError;
    
    const passwordError = validatePassword(credentials.password);
    if (passwordError) errors.password = passwordError;
    
    return errors;
};

export const validateSignupForm = (data: SignupData): FormErrors => {
    const errors: FormErrors = {};
    
    const firstNameError = validateName(data.firstName, 'firstName');
    if (firstNameError) errors.firstName = firstNameError;
    
    const lastNameError = validateName(data.lastName, 'lastName');
    if (lastNameError) errors.lastName = lastNameError;
    
    const emailError = validateEmail(data.email);
    if (emailError) errors.email = emailError;
    
    const passwordError = validatePassword(data.password);
    if (passwordError) errors.password = passwordError;
    
    if (!data.professionalRole) {
        errors.professionalRole = AUTH_ERROR_MESSAGES.PROFESSIONAL_ROLE_REQUIRED;
    }
    
    if (!data.agreeToTerms) {
        errors.agreeToTerms = AUTH_ERROR_MESSAGES.TERMS_REQUIRED;
    }
    
    return errors;
};

export const hasErrors = (errors: FormErrors): boolean => {
    return Object.values(errors).some(error => error !== null && error !== undefined);
};
